import React from 'react'
import { Divider } from 'primereact/divider'
import Logo from '../../../assets/images/koc-logo.svg'
import './NotificationRow.scss'
import { Notifications } from '../../../types/PushNotificationType'
import moment from 'moment'
import i18next from 'i18next'

const NotificationRow = (props: { message: Notifications }) => {
  return (
    <div
      className="p-2"
      style={!props.message.isRead ? { color: '#363636', cursor: 'pointer' } : { color: '#A8A8A8', cursor: 'pointer' }}>
      <div className="d-flex">
        <div className="logo-container">
          <img src={Logo} width="24px" height={'11px'} alt="logo" />
        </div>
        <div className="message-container">
          <h3>{props.message.title}</h3>
          <p>{props.message.content}</p>
        </div>
        <div className="message-time-container">
          <div className={props.message.isRead ? 'd-none' : 'new-message-circle'}></div>
          <p>{moment(props.message.sentDate).locale(i18next.language).fromNow()}</p>
        </div>
      </div>
      <Divider />
    </div>
  )
}

export default NotificationRow
